/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Offline_QuestionInputs */

const en_mobile_faq_offline_question = /** @type {(inputs: Mobile_Faq_Offline_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I listen to my documents offline?`)
};

const es_mobile_faq_offline_question = /** @type {(inputs: Mobile_Faq_Offline_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puedo escuchar mis documentos sin conexión?`)
};

/**
* | output |
* | --- |
* | "Can I listen to my documents offline?" |
*
* @param {Mobile_Faq_Offline_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_offline_question = /** @type {((inputs?: Mobile_Faq_Offline_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Offline_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_offline_question(inputs)
	return en_mobile_faq_offline_question(inputs)
});